import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IUipathJob } from 'app/rpa-bots/uipath/common/models/IUipathJob';
import { BZG_MODAL_DATA} from 'bz-genome-angular';


@Component({
  selector: 'bz-detail-jobs-modal',
  templateUrl: './detail-jobs-modal.component.html',
  styleUrls: ['./detail-jobs-modal.component.scss']
})
export class DetailJobsModalComponent implements OnInit {
  @Input() job: IUipathJob;
  @Input() inputArguments: any;

  constructor(@Inject(BZG_MODAL_DATA) public initialData: IUipathJob) {
      if (initialData.InputArguments) {
        this.inputArguments = JSON.parse(initialData.InputArguments);
      }
      else {
        this.inputArguments = null;
      }
  }

  ngOnInit() {
  }


}
